import React from 'react';
import s from './ServiciosCard.module.css';
import 'font-awesome/css/font-awesome.min.css';

export default function ServiciosCard({servicio}) {

    const formatHtml = function(){

        let aux = servicio.cuerpo.replaceAll("<li>", "<li><i class='fa fa-solid fa-gear'></i>");

        // let aux = servicio.cuerpo.split("<li>")
        // aux.forEach(((item, i)=>{
        //     if (!i) return;
        //     item = item.split("</li>")[0]
        //     aux[i] = `<li><i class='fa fa-solid fa-gear'></i><p>${item}</p></li>`;
        // }))
        // aux = aux.join("");

        return aux;

    }

  return (
    <div className={s.container}>
        <p className={s.title}>{servicio.nombre}</p>
        <div className="ulContainer" dangerouslySetInnerHTML={{ __html: formatHtml() }} />
    </div>
  )
}

// <FontAwesomeIcon className={s.engranaje} icon={faGear} color="#139E13"/>